import { motion } from "framer-motion";
import { CalendarCheck, Wallet } from "lucide-react";

const PROVIDERS = ["Sezzle", "Klarna", "Affirm", "Zip"];

export const PaymentPlans = () => (
  <div className="rounded-3xl bg-[var(--cream)] p-6 text-left sm:p-10" data-testid="payment-plans">
    <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-[var(--mauve-dark)]">Flexible payment options</p>
    <h3 className="font-display mt-4 text-center text-3xl font-light leading-tight [text-wrap:balance] sm:text-4xl" data-testid="payment-plans-heading">
      Start now. <em className="text-[var(--mauve)]">Pay over time.</em>
    </h3>
    <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="payment-providers">
      {PROVIDERS.map((p, i) => (
        <motion.div
          key={p}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.5, delay: i * 0.06 }}
          className="grid h-16 place-items-center rounded-2xl border border-[var(--blush-deep)] bg-white text-lg font-bold tracking-tight text-[var(--ink)]"
          data-testid={`payment-provider-${p.toLowerCase()}`}
        >
          {p}
        </motion.div>
      ))}
    </div>
    <div className="mt-8 grid gap-4 sm:grid-cols-2">
      <div className="flex gap-4 rounded-2xl bg-white p-5">
        <Wallet className="mt-0.5 h-6 w-6 shrink-0 text-[var(--mauve)]" aria-hidden="true" />
        <p className="text-base leading-relaxed text-[var(--ink)]">
          A lot of courses ask for the full price upfront. With The Boss Suite, you can split it into smaller payments with Sezzle, Klarna, Affirm, or Zip.
        </p>
      </div>
      <div className="flex gap-4 rounded-2xl bg-white p-5">
        <CalendarCheck className="mt-0.5 h-6 w-6 shrink-0 text-[var(--mauve)]" aria-hidden="true" />
        <p className="text-base leading-relaxed text-[var(--ink)]">
          That means starting doesn't have to wipe out your grocery money or wait until "someday." You can begin learning now and pay over time.
        </p>
      </div>
    </div>
    <p className="mt-6 text-center text-sm text-[var(--muted)]" data-testid="payment-plans-note">
      Payment plans are offered by each provider and are subject to their approval and terms.
    </p>
  </div>
);
